const skillsTotalOption = ({kid_name, ordering, skills_completed}) => {

  if (!kid_name) return null;

  const title = skills_completed && skills_completed > 5 ? 'Total skills learnt across the curriculum' : `Ready to rock,`;
  const subTitle = skills_completed && skills_completed > 5 ? `What an amazing achievement` : 'Total skills across the curriculum'

  const skillsTotalData = {
    "order": ordering.skills_completed,
    "name": "skills_completed",
    "tracking": skills_completed && skills_completed > 5 ? "skills_completed" : "skills_completed_fallback",
    "colorOption": 3,
    "dataPoints": {
      skills_completed,
      title,
      subTitle,
      kid_name
    }
  };
  return skillsTotalData;
}

export default skillsTotalOption;

